// eslint-disable-next-line import/prefer-default-export
export const KEY_FEATURES_MIN_MOBILE_HEIGHT = 70;
